export default {
  inject: ['$validator'],
  props: {
    value: Object
  },
  watch: {
    'value': {
      handler(val) {
        if (val) {
          Object.assign(this.form, val)
        }
      },
      immediate: true
    },
    'form': {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true,
      immediate: true
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/sub-form.mixin.js